package com.rainbowclubs.rainbow.presentation.admin

import com.rainbowclubs.rainbow.data.models.MembershipDataItem
import com.rainbowclubs.rainbow.data.models.MembershipDataTypes
import org.jetbrains.compose.resources.StringResource

data class ManageClubUiState(
    val isLoading: Boolean = true,
    val name: String = "",
    val description: String = "",
    val membershipData: List<MembershipDataItem> = emptyList(),
    val clubImageUrl: String? = null,
    val clubImageBytes: ByteArray? = null,
    val selectedImageName: String? = null,
    val isSubmitting: Boolean = false,
    val nameError: StringResource? = null,
    val formError: StringResource? = null,
    val editor: MembershipDataEditorUiState? = null,
)

data class MembershipDataEditorUiState(
    val index: Int?,
    val label: String,
    val type: MembershipDataTypes,
    val required: Boolean,
    val labelError: StringResource? = null,
) {
    val isNew: Boolean
        get() = index == null
}
